import { gql } from '@apollo/client';
import CLASSROOM_PRIVILEGE_FRAGMENT from './classroom-privilege';
import CLASSROOM_ROLE_FRAGMENT from './classroom-role';
import USER_FRAGMENT from './user';

const CLASSROOM_USER_ENROLLMENT_FRAGMENT = gql`
  fragment BaseClassroomUserEnrollment on UserClassroomEnrollment {
    userId
    user {
      ...BaseUser
    }
    classroomRoles {
      ...BaseClassroomRole
      privileges {
        ...BaseClassroomPrivilege
      }
    }
  }
  ${USER_FRAGMENT}
  ${CLASSROOM_ROLE_FRAGMENT}
  ${CLASSROOM_PRIVILEGE_FRAGMENT}
`;

export default CLASSROOM_USER_ENROLLMENT_FRAGMENT;
